import revive_payload_client_4sVQNw7RlN from "/var/www/pricing.bigam-dev.ru/data/www/client/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/var/www/pricing.bigam-dev.ru/data/www/client/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/var/www/pricing.bigam-dev.ru/data/www/client/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/var/www/pricing.bigam-dev.ru/data/www/client/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/var/www/pricing.bigam-dev.ru/data/www/client/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/var/www/pricing.bigam-dev.ru/data/www/client/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_UciE0i6zes from "/var/www/pricing.bigam-dev.ru/data/www/client/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import components_plugin_KR1HBZs4kY from "/var/www/pricing.bigam-dev.ru/data/www/client/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/var/www/pricing.bigam-dev.ru/data/www/client/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import plugin_client_RZVNejKJBe from "/var/www/pricing.bigam-dev.ru/data/www/client/node_modules/@samk-dev/nuxt-vcalendar/dist/runtime/plugin.client.js";
import slideovers_X7whXyrIWR from "/var/www/pricing.bigam-dev.ru/data/www/client/node_modules/@nuxt/ui/dist/runtime/plugins/slideovers.js";
import modals_oqljskDzoR from "/var/www/pricing.bigam-dev.ru/data/www/client/node_modules/@nuxt/ui/dist/runtime/plugins/modals.js";
import colors_ETtiVmZNmO from "/var/www/pricing.bigam-dev.ru/data/www/client/node_modules/@nuxt/ui/dist/runtime/plugins/colors.js";
import plugin_client_OVoKJro5pc from "/var/www/pricing.bigam-dev.ru/data/www/client/node_modules/@nuxtjs/color-mode/dist/runtime/plugin.client.js";
import plugin_WLsn00x1qh from "/var/www/pricing.bigam-dev.ru/data/www/client/node_modules/@nuxt/icon/dist/runtime/plugin.js";
import laravel_echo_client_xHFhfajl0H from "/var/www/pricing.bigam-dev.ru/data/www/client/plugins/laravel-echo.client.ts";
import apiUrl_mKpmUDhwmG from "/var/www/pricing.bigam-dev.ru/data/www/client/plugins/apiUrl.ts";
import breadCrumbs_8eIqdTeYLg from "/var/www/pricing.bigam-dev.ru/data/www/client/plugins/breadCrumbs.ts";
import pixi_client_pmHejJdQ2P from "/var/www/pricing.bigam-dev.ru/data/www/client/plugins/pixi.client.ts";
import v_instance_client_njXTVoQABq from "/var/www/pricing.bigam-dev.ru/data/www/client/plugins/v-instance.client.ts";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_client_UciE0i6zes,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  plugin_client_RZVNejKJBe,
  slideovers_X7whXyrIWR,
  modals_oqljskDzoR,
  colors_ETtiVmZNmO,
  plugin_client_OVoKJro5pc,
  plugin_WLsn00x1qh,
  laravel_echo_client_xHFhfajl0H,
  apiUrl_mKpmUDhwmG,
  breadCrumbs_8eIqdTeYLg,
  pixi_client_pmHejJdQ2P,
  v_instance_client_njXTVoQABq
]